import { Document, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

const GoodsIssuedPDF = ({ page_data, tenant_info }) => {
 const [pdfData, setPDFData] = useState(page_data);

 useEffect(() => {
  console.log(page_data);
  setPDFData(page_data);
 }, [page_data]);

 const styles = StyleSheet.create({
  page: {
   padding: 25,
   fontFamily: "Lato",
   backgroundColor: "#f9f9f9",
   fontSize: 9
  },

  header: {
   flexDirection: 'row',
   alignItems: 'flex-start',
   justifyContent: 'space-between',
   marginBottom: 15,
   borderBottom: '1px solid #e1e1e1',
   paddingBottom: 15
  },
  logoContainer: {
   flex: 1
  },
  logo: {
   width: "auto",
   height: 70
  },
  titleContainer: {
   flex: 2,
   textAlign: 'center',
   paddingTop: 10
  },
  companyName: {
   fontSize: 16, // Slightly smaller
   fontWeight: "bold",
   color: '#2c3e50'
  },
  documentTitle: {
   fontSize: 14, // Slightly smaller
   fontWeight: "semibold",
   marginTop: 10,
   color: '#3498db'
  },
  infoContainer: {
   flex: 1,
   textAlign: 'right'
  },
  infoText: {
   fontSize: 8,
   color: '#7f8c8d',
   marginBottom: 2
  },

  productBox: {
   borderWidth: 1,
   borderColor: "#ddd",
   padding: 10,
   borderRadius: 5,
   marginBottom: 15,
   backgroundColor: "#fff",
   flexDirection: "row",
   flexWrap: "wrap",
  },

  row: {
   width: "50%",  // Each row takes half the width
   flexDirection: "row",
   justifyContent: "space-between",
   marginBottom: 4,
   paddingRight: 10,  // Optional: add some spacing between columns
  },

  label: {
   fontWeight: "bold",
   color: "#555",
   flex: 1,  // Allows label to take available space
  },

  value: {
   color: "#222",
   flex: 2,  // Value takes twice the space of label
   textAlign: "right",  // Aligns value to the right within its space
  },

  table: {
   borderWidth: 1,
   borderColor: "#ddd",
   borderRadius: 5,
   overflow: "hidden"
  },

  tableHeader: {
   flexDirection: "row",
   backgroundColor: "#3498db",
   padding: 6
  },

  th: {
   color: "#fff",
   fontSize: 8,
   fontWeight: "bold",
   textAlign: "center"
  },

  tr: {
   flexDirection: "row",
   padding: 6,
   borderBottomWidth: 1,
   borderColor: "#eee"
  },

  td: {
   fontSize: 8,
   textAlign: "center"
  },

  td_no_center: {
   fontSize: 8
  },

  footer: {
   position: "absolute",
   bottom: 20,
   left: 25,
   right: 25,
   textAlign: "center",
   fontSize: 8,
   color: "#999"
  }
 });

 return (
  <>
   <Document>
    <Page size="A4" orientation="landscape" style={styles.page}>

     {/* HEADER */}
     <View style={styles.header} fixed>
      <View style={styles.logoContainer}>
       {tenant_info?.tenant_logo && <Image style={styles.logo} src={tenant_info?.tenant_logo} />}
      </View>

      <View style={styles.titleContainer}>
       <Text style={styles.companyName}>{tenant_info?.name}</Text>
       <Text style={styles.documentTitle}>GOODS ISSUED DETAILS</Text>
      </View>

      <View style={styles.infoContainer}>
       <Text style={styles.infoText}>Date: {new Date().toLocaleDateString()}</Text>
      </View>
     </View>

     {/* TABLE */}
     <View style={styles.table}>

      {/* HEADER */}
      <View style={styles.tableHeader}>
       {["Date", "Warehouse Site", "Message", "Size", "Color", "Units"].map((h, i) => {
        // Assign widths: index 1 (Message) gets 30%, others get 14%
        const width = i === 3 ? "30%" : "14%";
        return (
         <Text key={i} style={[styles.th, { width }]}>
          {h}
         </Text>
        );
       })}
      </View>

      {/* ROWS */}
      {pdfData?.map((item, index) => (
       <View
        key={index}
        style={[
         styles.tr,
         { backgroundColor: index % 2 === 0 ? "#fff" : "#f4f6f7" }
        ]}
       >
        <Text style={[styles.td, { width: "14%" }]}>
         {item?.inventory?.inserted_at ? moment(item?.inventory?.inserted_at).format("YYYY-MM-DD HH:mm") : "--"}
        </Text>
        <Text style={[styles.td, { width: "14%" }]}>
         {item?.warehouse_site?.name || "--"}
        </Text>
        <Text style={[styles.td_no_center, { width: "30%" }]}>
         {item?.inventory?.inventory_audit?.message || "--"}
        </Text>

        <Text style={[styles.td, { width: "14%" }]}>
         {item?.inventory?.packet_size || "--"}
        </Text>

        <Text style={[styles.td, { width: "14%" }]}>
         {item?.inventory?.color || "--"}
        </Text>

        <Text style={[styles.td, { width: "14%" }]}>
         {item?.inventory?.units || "0"}
        </Text>
       </View>
      ))}
     </View>

     {/* FOOTER */}
     <Text style={styles.footer}>
      Generated on {moment().format("YYYY-MM-DD HH:mm")}
     </Text>
    </Page>
   </Document>
  </>
 );
};

export default GoodsIssuedPDF;